var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarPencil = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.24141 16.8927H3.75C3.58424 16.8927 3.42527 16.8268 3.30806 16.7096C3.19085 16.5924 3.125 16.4334 3.125 16.2677V12.7763C3.12508 12.6107 3.19082 12.452 3.30781 12.3349L12.9422 2.70049C13.0594 2.58337 13.2183 2.51758 13.384 2.51758C13.5497 2.51758 13.7086 2.58337 13.8258 2.70049L17.3172 6.18955C17.4343 6.30675 17.5001 6.46566 17.5001 6.63135C17.5001 6.79704 17.4343 6.95595 17.3172 7.07315L7.68281 16.7099C7.56569 16.8269 7.40695 16.8926 7.24141 16.8927Z",
  stroke: "#6B5CE8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.625 5.01758L15 9.39258",
  stroke: "#6B5CE8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_pencil.f44f0f04418fea6d6c643a28dc90533e.svg";